import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';

export class BusServices {
  private static services = ['AUTH', 'USER', 'DIALER'];
  static async init(iframe?: HTMLIFrameElement) {
    if (!iframe) {
      iframe = await BusIframe.getIframe();
    }

    const event: BusEvent = {
      type: 'BUS.INIT',
      payload: { services: this.services },
    };

    return BusEventsPromisifier.promisifySyncEvent({
      event,
      fulfilled: 'BUS.INIT_FULFILLED',
      target: iframe,
    });
  }

  static async storeAgentList(iframe?: HTMLIFrameElement) {
    if (!iframe) {
      iframe = await BusIframe.getIframe();
    }

    const event: BusEvent = {
      type: 'API.LOOKUP_TEAMMATES',
      payload: {
        pageRequest: {
          limit: 100,
        },
        // A filter can be provided by filters.query field
      },
    };

    return BusEventsPromisifier.promisifySyncEvent({
      event,
      fulfilled: 'API.LOOKUP_TEAMMATES_FULFILLED',
      target: iframe,
    });
  }

  static async storeTeamList(iframe?: HTMLIFrameElement) {
    if (!iframe) {
      iframe = await BusIframe.getIframe();
    }

    const event: BusEvent = {
      type: 'API.SEARCH_TEAMS',
      payload: {
        variables: {
          from: 0,
          limit: 100,
        },
      },
    };

    return BusEventsPromisifier.promisifySyncEvent({
      event,
      fulfilled: 'API.SEARCH_TEAMS_FULFILLED',
      target: iframe,
    });
  }

  static destroy(iframe: HTMLIFrameElement) {
    const event: BusEvent = {
      type: 'BUS.DESTROY',
      payload: { services: this.services },
    };

    return BusEventsPromisifier.promisifySyncEvent({
      event,
      fulfilled: 'BUS.DESTROY_FULFILLED',
      target: iframe,
    });
  }

  static async subscribeIntegrationSettingUpdate(
    iframe: HTMLIFrameElement,
    companyId: number,
  ) {
    const busEvent: BusEvent = {
      type: 'SUBSCRIBE.INTEGRATION_SETTING_UPDATE',
      payload: {
        variables: {
          companyId: companyId,
        },
      },
    };

    await BusEventsPromisifier.promisifyFireAndForgetEvent({
      target: iframe,
      event: busEvent,
    });
  }
}
